import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Tin thị trường (MarketNewsScreen.tsx). Tiêu đề / tóm tắt tin, tên nguồn, mã hãng, loại thông báo (Delay, Blank sailing…) và nhãn loại nguồn (news.ts) không dịch.
addMessages('vi', {
  'mn.lang': 'Ngôn ngữ',
  'mn.vi': 'Tiếng Việt',
  'mn.sum': 'Hana tóm tắt',
  'mn.rel': 'Điểm liên quan {n}/5',
  'mn.find': 'Tìm',
  'mn.findPh': 'Tiêu đề, hãng, nội dung…',
  'mn.sources': 'Nguồn tin',
  'mn.allSources': 'Tất cả nguồn',
  'mn.onlyRel': 'Chỉ tin liên quan (điểm ≥ {n})',
  'mn.viTitle': 'Tiêu đề tiếng Việt (Hana dịch)',
  'mn.countN': '{a} / {b} tin',
  'mn.noNews': 'Không có tin phù hợp',
  'mn.noNewsD': 'Bỏ bớt bộ lọc hoặc tắt ≥ 3.',
  'mn.news': 'Tin tức',
  'mn.read': 'Đọc',
  'mn.hideAria': 'Ẩn tin không liên quan · {v}',
  'mn.hide': 'Ẩn · không liên quan',
  'mn.newsN': '{n} tin',
  'mn.lowHidden': '{a} tin điểm < {b} đang ẩn',
  'mn.carrier': 'Hãng',
  'mn.type': 'Loại',
  'mn.notice': 'Thông báo',
  'mn.effective': 'Hiệu lực',
  'mn.amount': 'Mức',
  'mn.channel': 'Kênh',
  'mn.carrierFilter': 'Lọc hãng',
  'mn.all': 'Tất cả',
  'mn.carrierNotice': 'Thông báo hãng',
  'mn.indices': 'Chỉ số tổng hợp',
  'mn.noWrite': 'Chưa bật ghi nguồn feed',
  'mn.source': 'Nguồn',
  'mn.detail': 'Chi tiết (URL · lọc)',
  'mn.on': 'Bật',
  'mn.enable': 'Bật nguồn {v}',
  'mn.lastRun': 'Lần chạy cuối',
  'mn.never': 'Chưa chạy',
  'mn.err': 'lỗi',
  'mn.items7': 'Tin 7 ngày',
  'mn.run': 'Chạy',
  'mn.edit': 'Sửa',
  'mn.feed': 'Nguồn feed',
  'mn.feedFoot': '{a} nguồn · {b} lỗi lần chạy cuối',
  'mn.tNews': 'Tin tức',
  'mn.tIdx': 'Chỉ số cước',
  'mn.feedErr': 'Nguồn feed {n} lỗi',
  'mn.refreshNews': 'Làm mới tin',
  'mn.refreshNotice': 'Làm mới thông báo',
  'mn.refreshIdx': 'Cập nhật chỉ số',
  'mn.addSource': 'Thêm nguồn',
  'mn.title': 'Tin thị trường',
  'mn.section': 'Mục',
  'mn.more': 'Thao tác khác',
  'mn.readOnly': 'Chỉ đọc tin · chỉ quản trị viên quản lý nguồn feed.',
  'mn.emptyT': 'Chưa có tin nào',
  'mn.errT': 'Không tải được tin thị trường',
  'mn.nopermT': 'Không có quyền xem tin',
  'mn.errD': 'Không tải được tin mới. Tin đã đọc vẫn còn trong lịch sử.',
  'mn.retry': 'Thử lại',
  'mn.close': 'Đóng',
  'mn.idxWeek': 'Chỉ số cước tuần này',
  'mn.soon7': 'Thông báo hãng có hiệu lực 7 ngày tới',
  'mn.effOn': 'Hiệu lực {v}',
  'mn.none': 'Không có.',
});
addMessages('en', {
  'mn.lang': 'Language',
  'mn.vi': 'Vietnamese',
  'mn.sum': 'Hana summary',
  'mn.rel': 'Relevance {n}/5',
  'mn.find': 'Search',
  'mn.findPh': 'Title, carrier, content…',
  'mn.sources': 'News sources',
  'mn.allSources': 'All sources',
  'mn.onlyRel': 'Relevant news only (score ≥ {n})',
  'mn.viTitle': 'Vietnamese titles (translated by Hana)',
  'mn.countN': '{a} / {b} items',
  'mn.noNews': 'No matching news',
  'mn.noNewsD': 'Remove filters or turn off ≥ 3.',
  'mn.news': 'News',
  'mn.read': 'Read',
  'mn.hideAria': 'Hide irrelevant item · {v}',
  'mn.hide': 'Hide · not relevant',
  'mn.newsN': '{n} items',
  'mn.lowHidden': '{a} items scored < {b} hidden',
  'mn.carrier': 'Carrier',
  'mn.type': 'Type',
  'mn.notice': 'Notice',
  'mn.effective': 'Effective',
  'mn.amount': 'Amount',
  'mn.channel': 'Channel',
  'mn.carrierFilter': 'Filter carriers',
  'mn.all': 'All',
  'mn.carrierNotice': 'Carrier notices',
  'mn.indices': 'Composite indices',
  'mn.noWrite': 'Writing feed sources is not enabled',
  'mn.source': 'Source',
  'mn.detail': 'Details (URL · filter)',
  'mn.on': 'On',
  'mn.enable': 'Enable source {v}',
  'mn.lastRun': 'Last run',
  'mn.never': 'Never run',
  'mn.err': 'error',
  'mn.items7': 'Items 7d',
  'mn.run': 'Run',
  'mn.edit': 'Edit',
  'mn.feed': 'Feed sources',
  'mn.feedFoot': '{a} sources · {b} failed on last run',
  'mn.tNews': 'News',
  'mn.tIdx': 'Freight indices',
  'mn.feedErr': 'Feed sources {n} failing',
  'mn.refreshNews': 'Refresh news',
  'mn.refreshNotice': 'Refresh notices',
  'mn.refreshIdx': 'Update indices',
  'mn.addSource': 'Add source',
  'mn.title': 'Market news',
  'mn.section': 'Section',
  'mn.more': 'More actions',
  'mn.readOnly': 'Read-only news · only administrators manage feed sources.',
  'mn.emptyT': 'No news yet',
  'mn.errT': 'Could not load market news',
  'mn.nopermT': 'No permission to view news',
  'mn.errD': 'Could not load new items. Items already read remain in history.',
  'mn.retry': 'Retry',
  'mn.close': 'Close',
  'mn.idxWeek': 'Freight indices this week',
  'mn.soon7': 'Carrier notices effective in the next 7 days',
  'mn.effOn': 'Effective {v}',
  'mn.none': 'None.',
});
